var exports = {
  "psk": "x1cb7f6e3--a9cca9--psk",
  "phone": "x1cb7f6e3--a9cca9--phone",
};

module.exports = exports;
